export enum StyleModalEnum {
  CREATE_NEW_STYLE = 'create-new-style',
  CONVERT_STYLE = 'convert-style',
  IMPORT_STYLE = 'import-style',
}
